import React, {Component} from 'react';
import {connect} from 'react-redux';

class Home extends Component {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {
    }

    render() {
        return (
            <div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);




// WEBPACK FOOTER //
// ./src/containers/home/home.js